import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Sidebar.scss";
import Tooltip from "../../common/Tooltip/Tooltip";
import SitesGroupIcon from "../../../assets/img/asset_list_icon.png";
import GroupIcon from '../../../assets/img/Group.png';
import GroupSitesPanel from "./GroupSitesPanel";
import { useRef } from "react";


const Sidebar = ({ setSelectedNode, handleLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSideBarLoading, setIsSideBarLoading] = useState(false)
  const [sidePanelData, setSidePanelData] = useState([])
  const sidebarRef = useRef(null);
  const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT;
  const apiUrl = `${baseUrl}/Wells/GetWellHierarchy`;

  const ToggleSidebar = () => setIsOpen((prev) => !prev);

  const buildTree = (data, parentId = null) => {
    return data
      .filter((node) => node.parentId === parentId)
      .map((node) => ({
        ...node,
        children: buildTree(data, node.id) // Recursively attach children
      }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);


  useEffect(() => {
    setIsSideBarLoading(true);

    // Check if data is already in sessionStorage
    const cachedData = sessionStorage.getItem('wellHierarchyData');

    // If cached data is available, use it; otherwise, fetch from API
    if (cachedData) {
      setSidePanelData(buildTree(JSON.parse(cachedData)));
      setIsSideBarLoading(false); // No need to wait if using cached data
    } else {
      const fetchData = async () => {
        const headers = {
          'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
          'Content-Type': 'application/json', // Adjust content type if needed
        };
        try {
          const response = await fetch(apiUrl, { headers });
          if (response.status === 401) {
            handleLogout();
          }
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();

          // Cache the fetched data in sessionStorage
          sessionStorage.setItem('wellHierarchyData', JSON.stringify(data));

          // Update the state with the fetched data
          setSidePanelData(buildTree(data));
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setIsSideBarLoading(false); // Set loading to false whether the fetch was successful or not
        }
      };

      fetchData();
    }
  }, []); // Empty dependency array to run this effect only once on component mount


  return (
    <>
      <div className="fixed left-0 bottom-0 top-0 flex flex-col items-start justify-between bg-darkcolor-600 py-4 w-14 2xl:w-14 min-w-14 2xl:min-w-14 z-[60] sidebar">
        <div className="flex flex-col justify-center items-center w-full sidebar-toplinks">
          <img
            id="sitesGroupIcon"
            src={GroupIcon}
            alt="Group Icon"
            className="w-8 h-8 2xl:w-8 2xl:h-8"
          />
          <div className="flex flex-col justify-center w-full text-center px-2 pb-4 sidebar-logo"></div>
          <div className="flex flex-col justify-center w-full px-2 gap-2 sidebar-toplinks">
            <Tooltip content="Customer & groups" direction="right">
              <Link to="#" onClick={ToggleSidebar}>
                <div className="p-2 rounded-md cursor-pointer text-center hover:bg-primary-700 border-2 border-transparent hover:border-primary-500 iconbtn">
                  <img
                    id="sitesGroupIcon"
                    src={SitesGroupIcon}
                    alt="Sites Group Icon"
                    className="w-5 h-5 2xl:w-6 2xl:h-6"
                  />
                </div>
              </Link>
            </Tooltip>
          </div>
        </div>
      </div>

      {/* Sidebar Panel for Mobile */}
      {isOpen && (
        <div className="sidebar-overlay">
          <div ref={sidebarRef}>
            <GroupSitesPanel
              treeData={sidePanelData}
              setIsOpen={setIsOpen}
              setSelectedNode={setSelectedNode}
              isSideBarLoading={isSideBarLoading}
            />
          </div>
        </div>
      )}

    </>
  );
};

export default Sidebar;
